import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '@out-web/core';
import { AuthService } from '@auth0/auth0-angular';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'out-cash-offer',
  imports: [CommonModule, RouterLink],
  templateUrl: './cash-offer.component.html',
  styleUrl: './cash-offer.component.scss',
})
export class CashOfferComponent implements OnInit {
  constructor(
      private seoService: SeoService,
      public auth: AuthService
    ) { }
    ngOnInit(): void {
      this.setMetaData();
    }
  
    private setMetaData() {
      const title = 'Instant Tesla Cash Offers & Dealer Desk | Only Used Tesla';
      const description = 'Get a firm cash offer for any Tesla in ≤30 min and chat directly with licensed buyers. Powered by OUT-CONNECT battery & feature verification and Stripe Identity fraud protection.';
      const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
      const url = 'https://onlyusedtesla.com/cash-offer';
  
      this.seoService.setMetaData(title, description, imageUrl, url);
    }
}
